import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import '../App.css';

/**
 * Custom Error Page component for handling errors within React Router
 * This component is used when accessing error routes through React Router
 */
const ErrorPage = () => {
  const location = useLocation();
  const [errorCode, setErrorCode] = useState('404');
  
  useEffect(() => {
    // Extract error code from URL if available
    const params = new URLSearchParams(location.search);
    const code = params.get('code') || '404';
    setErrorCode(code);
    
    // Set page title
    document.title = `Error ${code} - GTA VI Countdown`;
  }, [location]);

  // Get error message based on error code
  const getErrorMessage = (code) => {
    switch (code) {
      case '400':
        return 'Bad Request - The server could not understand your request.';
      case '401':
        return 'Unauthorized - You need to provide authentication to access this resource.';
      case '403':
        return 'Forbidden - You do not have permission to access this resource.';
      case '404':
        return 'Page Not Found - The requested URL was not found on this server.';
      case '500':
        return 'Internal Server Error - The server encountered an unexpected condition.';
      case '502':
        return 'Bad Gateway - The server received an invalid response from the upstream server.';
      case '503':
        return 'Service Unavailable - The server is temporarily unable to handle the request.';
      case '504':
        return 'Gateway Timeout - The server did not receive a timely response from the upstream server.';
      default:
        return 'An error occurred.';
    }
  };

  return (
    <div className="error-container">
      <div className="error-content">
        <div className="error-logo-container">
          <img 
            src="/img/icons/official-gta-vi-logo.webp" 
            alt="GTA VI Logo" 
            className="error-logo"
          />
        </div>
        
        <h1 className="error-code">Error {errorCode}</h1>
        <p className="error-message">{getErrorMessage(errorCode)}</p>
        
        <div className="error-actions">
          <Link to="/" className="error-btn">
            Return to Countdown
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
